import { render } from "./FooterSection.vue?vue&type=template&id=3495b8c4&scoped=true"
const script = {}

import "./FooterSection.vue?vue&type=style&index=0&id=3495b8c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3495b8c4"]])

export default __exports__